module.exports = fox._r("htmlplayer/images/acplayer-robot-title.png", __webpack_public_path__ + "_/_/_/_/common-components/htmlplayer/images/acplayer-robot-title.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/images/acplayer-robot-title.png
// module id = 543
// module chunks = 4